export default "__VITE_ASSET__CiKGSy3$__"